var _path, _path2, _path3, _path4, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 199,
    viewBox: "0 0 293 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56213 117.884L0 108.253V182H282V35.8104L272.544 49.1388L264.201 44.4893L255.858 14.2682L246.929 3L236.947 42.1646L228.047 75.3747L219.704 87.3304L210.249 95.6329L201.905 66.7401L192.45 95.6329L184.107 170.688L165.751 93.9724L156.852 108.253L147.953 140.799L130.154 154.747L121.254 143.123L112.355 157.072L103.456 123.529L94.5562 128.179L85.6568 75.3747L77.3136 71.0574L67.3018 67.7364L58.4024 69.0648L50.0592 117.884L40.6035 138.474L32.2604 145.116L23.3609 161.721L14.4615 113.566L5.56213 117.884Z",
    fill: "url(#paint0_linear_1181_71975)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.253L5.56213 117.884L14.4615 113.566L23.3609 161.721L32.2604 145.116L40.6035 138.474L50.0592 117.884L58.4024 69.0648L67.3018 67.7364L77.3136 71.0574L85.6568 75.3748L94.5562 128.179L103.456 123.529L112.355 157.072L121.254 143.123L130.154 154.747L147.953 140.799L156.852 108.253L165.751 93.9724L184.107 170.688L192.45 95.6329L201.905 66.7401L210.249 95.6329L219.704 87.3304L228.047 75.3748L236.947 42.1646L246.929 3L255.858 14.2682L264.201 44.4893L272.544 49.1388L282 35.8104",
    stroke: "#7A76FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 68H292",
    stroke: "#B6B7C3",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202 3L202 198",
    stroke: "#B6B7C3",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 67,
    r: 3.25,
    fill: "white",
    stroke: "#9DA3FF",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1181_71975",
    x1: 141,
    y1: 3,
    x2: 141,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A29FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphImage);
export default __webpack_public_path__ + "static/media/graph-image.a24ff0b27615301183ea2add176c569a.svg";
export { ForwardRef as ReactComponent };